import { createSlice } from '@reduxjs/toolkit';

const departmentSlice = createSlice({
  name: 'department',
  initialState: {
    departmentList: [],
    isSuccess: false,
  },
  reducers: {
    initialDepartment: state => {},
    createDepartment: () => {},
    createDepartmentSuccess: (state, payload) => {
      state.isSuccess = payload;
    },
    createDepartmentFail: state => {
      state.isSuccess = false;
    },
    deleteDepartment: () => {},
    deleteDepartmentSuccess: (state, payload) => {
      state.isSuccess = payload;
    },
    deleteDepartmentFail: (state, payload) => {
      state.isSuccess = false;
    },
    updateDepartment: (state, { payload }) => {
      const newData = {
        deptNm: payload.deptNm,
        deptCd: payload.deptCd,
        enDeptNm: payload.enDeptNm,
      };
      const _deptListArray = state.departmentList;
      _deptListArray.push(newData);
      state.departmentList = _deptListArray;
      state.isSuccess = true;
    },
    removeDepartment: (state, { payload }) => {
      const _deptListArray = state.departmentList.filter(item => item.deptCd !== payload.deptCd);
      state.departmentList = _deptListArray;
    },
  },
});

export const {
  createDepartment,
  createDepartmentSuccess,
  createDepartmentFail,
  deleteDepartment,
  deleteDepartmentSuccess,
  deleteDepartmentFail,
  updateDepartment,
  removeDepartment,
} = departmentSlice.actions;
export default departmentSlice.reducer;
